/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { capitalizeFirstLetter, getComponentFromName } from '../../lib/utils';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/blocks/blocks.module.scss';

const propTypes = {
    blocks: AppPropTypes.blocks,
    components: AppPropTypes.components.isRequired,
    blockProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
    blockClassName: PropTypes.string,
    typeClassName: PropTypes.objectOf(PropTypes.string),
    isContainer: PropTypes.bool,
    firstInPage: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    blocks: [],
    blockProps: null,
    className: null,
    blockClassName: null,
    typeClassName: {},
    isContainer: false,
    firstInPage: false,
    containerClassName: null,
};

const BaseBlocks = ({
    blocks,
    components,
    blockProps,
    className,
    blockClassName,
    typeClassName,
    isContainer,
    firstInPage,
    containerClassName,
}) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        {(blocks || []).map((block, index) => {
            const { type, isVideoSlot = false } = block || {};
            const BlockComponent = getComponentFromName(components, type);
            if (BlockComponent === null && process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn(`Missing block ${type}`);
            }
            const isLastBlock = index === blocks.length - 1;

            return BlockComponent !== null ? (
                <div
                    key={`block-${block.id}`}
                    className={classNames([
                        styles.block,
                        {
                            [styles[`blockWrap${capitalizeFirstLetter(type)}`]]: type !== null,
                            [styles.firstInPage]: firstInPage,
                            [styles.isLast]: isLastBlock,
                            [blockClassName]: blockClassName !== null,
                        },
                    ])}
                >
                    <BlockComponent
                        id={block.id}
                        isLast={isLastBlock}
                        isContainer={isContainer}
                        className={classNames([
                            styles[`block-${type}`],
                            {
                                ...{
                                    [typeClassName[type] || null]:
                                        typeof typeClassName[type] === 'string',
                                },
                                [styles.isSlot]: isVideoSlot,
                            },
                        ])}
                        containerClassName={containerClassName}
                        isVideoSlot={isVideoSlot}
                        currentIndex={index}
                        {...block}
                        {...blockProps}
                    />
                </div>
            ) : null;
        })}
    </div>
);

BaseBlocks.propTypes = propTypes;
BaseBlocks.defaultProps = defaultProps;

export default BaseBlocks;
